"use strict";function invokeThingService$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.invokeThingService$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.iot.invokeThingService";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"4.6.42"},_a[ddSdk_1.ENV_ENUM.android]={vs:"4.6.42"},_a)),exports.invokeThingService$=invokeThingService$,exports.default=invokeThingService$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/iot/invokeThingService.js
// module id = 958
// module chunks = 106